import { Context } from "@nuxt/types/app";
import formatCurrency from "format-currency";

interface DecimalFormatHelper {
  decimalFormat: (val: null | number | string) => string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (_context?: Context): DecimalFormatHelper {
  // from '10000' to '10.000'
  function decimalFormat(val: null | number | string): string {
    if (val === null) return "-";

    const formatted = formatCurrency(val, {
      symbol: "",
      format: "%s%v",
      locale: "id",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatted;
  }

  return { decimalFormat };
}
